import { render } from "./receive_deliverable.vue?vue&type=template&id=77d7b97f"
import script from "./receive_deliverable.vue?vue&type=script&lang=js"
export * from "./receive_deliverable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__